import {
  formatPercentageValue,
  formatValueWithMiddlewares,
  checkForNA,
  appendPercentage,
  createKpiTileItem,
  formatTimeWithSeconds,
} from '../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { downTimeSeconds, downTimePercentage, downTimePercentageDelta } =
      data;

    // Format downTimeHours using formatTimeWithSeconds and combine with percentage
    const formattedTime = formatTimeWithSeconds(downTimeSeconds);
    const formattedPercentage = formatPercentageValue(downTimePercentage);
    const combinedValue = `${formattedTime} (${formattedPercentage})`;

    return createKpiTileItem(
      'Downtime',
      combinedValue,
      downTimePercentageDelta
        ? {
            isPositiveValue: downTimePercentageDelta >= 0,
            text: formatValueWithMiddlewares(
              Math.abs(downTimePercentageDelta),
              [checkForNA, appendPercentage]
            ).toString(),
            sideLabel: '',
            showArrow: downTimePercentageDelta !== 0,
          }
        : []
    );
  },
};
